import Result from "@/core/common/Result";
import {
  IObterMensagemBoasVindasGateway,
  ObterMensagemBoasVindasResponse
} from "../ports/ObterMensagemBoasVindasGateway";
import { inject, injectable } from "inversify";
import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "@/core/services/protocols/types";
import { ContabilGatewayError } from "../../diagnostico/config/ContabilGatewayError";
import { IDefaultContabilResponse } from "@/features/contabil/services/types";

@injectable()
export class ObterMensagemBoasVindasGatewayAdapter
  extends ContabilGatewayError
  implements IObterMensagemBoasVindasGateway
{
  @inject(DITypes.CONTABIL_HTTP_CLIENT)
  private readonly httpClient!: HttpClient;

  async getMensagemBoasVindas(): Promise<
    Result<ObterMensagemBoasVindasResponse>
  > {
    try {
      const response = await this.httpClient.post<
        IDefaultContabilResponse<ObterMensagemBoasVindasResponse>
      >({
        url: "v1/contabil/primeiro-acesso/pode-visualizar-mensagem-boas-vindas"
      });

      if (this.hasError(response)) {
        return Result.fail("Não foi possível buscar a mensagem de boas vindas");
      }

      return Result.ok(response.body?.result);
    } catch (_error) {
      return Result.fail(this.DEFAULT_ERROR);
    }
  }
}
